
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      homeTeamForm: [],
      awayTeamForm: [],
    };
  },
  computed: {
    homeTeam () {
      return this.getTeam(this.fixture, `Home`);
    },
    awayTeam () {
      return this.getTeam(this.fixture, `Away`);
    },
    season () {
      return this.getDefault(`season`);
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.getForm(this.homeTeam, `home`);
      this.getForm(this.awayTeam, `away`);
    });
  },
  methods: {
    async getForm (team, side) {
      const requestUrl = `previous-meeting/${team.team.id}`;
      const params = {
        season_id: this.season.id,
        limit: 4,
        datetime: this.fixture.datetime, // call returns matches before this time (not including)
      };

      const request = await this.$getCustomStats(requestUrl, params);
      if (request !== null) {
        this[`${side}TeamForm`] = request;
      }
    },
  },
};
